<template>
  <!-- <v-btn
    fab
    small
    text
    v-if="isMobile"
    @click="$store.commit('toggle', 'helpEnabled')"
    ><div class="help-button" :class="helpClass"
  /></v-btn>
  <v-btn
    fab
    small
    text
    v-else-if="!isMobile"
    @click="$store.commit('toggle', 'helpEnabled')"
    ><div class="help-button" :class="helpClass"
  /></v-btn> -->

  <v-btn
    fab
    small
    text
    v-if="isMobile"
    @click="sliteLink"
    ><div class="help-button" :class="helpClass"
  /></v-btn>
  <v-btn
    fab
    small
    text
    v-else-if="!isMobile"
    @click="sliteLink"
    ><div class="help-button" :class="helpClass"
  /></v-btn>
</template>

<script>
export default {
  name: "HelpButton",
  computed: {
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    helpShown() {
      return this.$store.state.mode.helpEnabled;
    },
    helpClass() {
      return this.$store.state.mode.darkMode ? 'grunticon__icon-ui-help-circle-white' : 'grunticon__icon-ui-help-circle-white'
    },
    helpDialog: {
      get() {
        return this.$store.state.mode.helpShown;
      },
      set() {
        this.$store.commit("toggle", "helpShown");
      },
    },
  },
  methods: {
    toggleDarkTheme() {
      this.$store.commit("toggle", "darkMode");
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    sliteLink() {
      window.open("https://getapio.slite.com/p/channel/LJ2C5LbtXG73iyCWc3bXek");
    }
  },
};
</script>

<style lang="scss" scoped>
  .help-button {
    height: 32px;
    width: 32px;
    background-size: cover;
  }
</style>